import React from "react";
import { Checkbox, FormControlLabel } from "@mui/material";

interface IFormCheckBoxProps {
    title: string;
    checked: boolean;
    disabled?: boolean;
    onChange: (checked: boolean) => void;
}

export const FormCheckBox = (props: IFormCheckBoxProps) => {
    return (
        <FormControlLabel
            label={props.title}
            control={
                <Checkbox
                    title={props.title}
                    checked={props.checked}
                    disabled={props.disabled}
                    onChange={(_e, checked: boolean) => {
                        props.onChange(checked);
                    }}
                />
            }
        />
    );
};